import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updateBannerApiCall({
  id,
  isPathDesign,
  mediaType,
  mediaUrl,

  bannerWidthView,
  bannerHeightView,
  bannerHeight,
  bannerWidth,
  bannerDarkness,
  isBannerText,
  bannerText,
  bannerTextColor,
  bannerDescription,

  CTAActionType,
  CTABackgroundColor,
  CTALinkId,
  CTABlockId,
  CTAOpacity,
  CTAUrl,
  CTAText,
  CTATextColor,
  CTABorder,
  CTABorderColor,
  CTAShadow,
  CTAShadowColor,
  CTAShape,

  bannerProductProvider,
  bannerProductSelect,
  bannerProductId,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.banner, isPathDesign), {
    id,
    mediaType,
    mediaUrl,

    widthView: bannerWidthView,
    width: bannerWidth,
    heightView: bannerHeightView,
    height: bannerHeight,
    darkness: Number(bannerDarkness),
    isText: isBannerText,
    text: bannerText,
    textColor: bannerTextColor,
    description: bannerDescription,

    ctaType: CTAActionType,
    ctaUrl: CTAUrl,
    ctaText: CTAText,
    ctaBackgroundColor: CTABackgroundColor,
    ctaTextColor: CTATextColor,
    ctaIsBorder: CTABorder,
    ctaBorderColor: CTABorderColor,
    ctaOpacity: CTAOpacity,
    ctaLinkId: CTALinkId,
    ctaBlockId: CTABlockId,
    ctaShape: CTAShape,
    ctaShadow: CTAShadow,
    ctaShadow_color: CTAShadowColor,

    productProvider: bannerProductProvider,
    productSelect: bannerProductSelect,
    productId: bannerProductId,

    isSectionBackground: sectionIsBackground,
    sectionBorderColor,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,
  });
}
